import { gql } from "@apollo/client";

export const GET_DEDUCTION_ACTIVITY = gql`
  query DeductionActivities($params: GetDeductionActivityParams!) {
    deductionActivities(params: $params) {
      deductionId
      hasMore
      total
      page
      limit
      items {
        id
        createdOn
        user {
          userId
          avatar
          fullName
          isDeleted
        }
        logs {
          message
          fileList
          fieldData {
            fieldName
            oldValue
            newValue
          }
        }
      }
    }
  }
`;
